var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_15","data-name":"Group 15","transform":"translate(314.248 2346.313) rotate(180)"},React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M.261,21.105,0,21.366l.261-.261L0,20.845l.261.261L21.366,0,.261,21.105,21.366,42.211Z","transform":"translate(292.175 2303.395)","fill":"none","stroke":"#00ffe2","strokeWidth":"2"})));
}

ArrowRight.defaultProps = {"viewBox":"0 0 23.227 43.625"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
